import React from 'react'
import App from '../components/App'

const AppPage = (props) => (
  <App router={props} />
)

export default AppPage



// WEBPACK FOOTER //
// ./src/pages/AppPage.js